<template>
    <div class="search-results-footer">
        <div>
            <p v-if="page">
                {{ $t('search.pager.title', [page.firstItem, page.lastItem, totalResultCount]) }}
            </p>
        </div>
        <div class="search-results-footer__middle">
            <VJoyPagination
                v-if="page"
                :total-pages="page.total ?? 1"
                :current-page="page.current"
                data-testid="pagination"
                :label-prev="$t('generic.navigation.button.prev')"
                :label-next="$t('generic.navigation.button.next')"
                @update:current-page="goToPage"
            />
            <VJoyPagination
                v-else-if="totalResultCount > 0"
                :total-pages="1"
                :current-page="1"
                :label-prev="$t('generic.navigation.button.prev')"
                :label-next="$t('generic.navigation.button.next')"
            />
        </div>
        <div class="search-results-footer__right"></div>
    </div>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyPagination} from '@maltjoy/core-vue';
    import {useProfilesStore} from '../stores/profiles.store';
    import {useSearchUrlStore} from '../stores/search-url.store';

    const profilesStore = useProfilesStore();
    const searchUrlStore = useSearchUrlStore();
    const {initialSearchResponse, remoteFallbackSearchResponse, europaFallbackSearchResponse, totalResultCount} = storeToRefs(profilesStore);
    const {searchUrlParams} = storeToRefs(searchUrlStore);

    const page = computed(() => {
        // the page we return is the page of the first search having more than one page (initial search, then remote fallback, then remote europa).
        if (initialSearchResponse.value && initialSearchResponse.value.pagination.total > 1) {
            return initialSearchResponse.value.pagination;
        }
        if (remoteFallbackSearchResponse.value && remoteFallbackSearchResponse.value.pagination.total > 1) {
            return remoteFallbackSearchResponse.value.pagination;
        }
        if (europaFallbackSearchResponse.value && europaFallbackSearchResponse.value.pagination.total > 1) {
            return europaFallbackSearchResponse.value.pagination;
        }
        return null;
    });

    function goToPage(pageNumber: number) {
        searchUrlParams.value.page = pageNumber;
        window.scrollTo({top: 0, behavior: 'smooth'});
    }
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint' as joy;

    .search-results-footer {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
        align-items: center;
        margin: var(--joy-core-spacing-8) 0;

        &__left {
            place-self: start;
        }

        &__middle {
            place-self: center;

            nav {
                margin: 0;
            }
        }

        &__right {
            place-self: end;
        }

        @include joy.screen_md {
            grid-template-columns: 1fr 1fr;

            * {
                place-self: center;
            }
        }

        @include joy.screen_xs {
            grid-template-columns: 1fr;
        }
    }
</style>
